export default __webpack_public_path__ + "static/media/collect-translate-2.5fbed535.webp";